export default __webpack_public_path__ + "static/media/aliopecia-areata.9a360466.JPG";